import {v4 as uuidv4} from 'uuid';
import {getRandomTopicColor} from '../../tools/colors';
import { Tables, TablesInsert } from '../database.types';

export type Topic = Omit<Tables<'topics'>, 'user_id'>;

export interface Dc3Topic {
  id: number;
  order: number | null | undefined;
  name: string;
  color: string;
  isPinned?: boolean;
  tracker?: {
    range: boolean;
    rangeTarget: 'HIGH' | 'MEDIUM' | 'LOW'
  },
  synced?: boolean;
  removed?: boolean;
  counter?: {
    values: number;
    content: number
  }
}

export const createTopic = (name: string, order: number): TablesInsert<'topics'> => ({
  name,
  color: getRandomTopicColor(),
  order_number: order,
  is_pinned: false
});
